import {translations} from 'presentation/translations-new';

const {searchProfessional, searchSpecialty} = translations['pt-br'].privateFlow.bookingFlow;

const SEARCH_BAR_PLACEHOLDER = [searchSpecialty, searchProfessional, ''];

export {SEARCH_BAR_PLACEHOLDER};
